module.exports = __webpack_public_path__ + "img/手表-2.84e4f1a8.png";